module.exports = __webpack_public_path__ + "img/expo-lobby-birdeye-view.be9ff44a.jpg";